import { SetItem } from "@/models/SetItem";

export class ImageGalleryDialogSetHelper {
  public getSetName(set: SetItem): string {
    return set && set.name
      ? set.name
      : '';
  }
}
